<empusa-core-spinner *ngIf="spinnerSrv.loading" [overlay]="true"></empusa-core-spinner>
<div class="modal-content">

  <div class="modal-header">
    <div style="display: flex; align-items: center;">
      <h3 class="modal-title font">Detalle de prefactura y factura</h3>
    </div>
    <button type="button" (click)="closeDialog()" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" style="max-height: 70vh; overflow-y: auto;">
    <form class="form-modal py-3" [formGroup]="modelForm">
      <div class="row form">
        <div class="col-sm flex-grow-2">
          <label for="gestor">Gestor</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="gestor" id="gestor" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="estado">Estado </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="estado" id="estado" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>
      <!--PREFACTURA-->
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="numeroPrefactura">Número de prefactura </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="numeroPrefactura" id="numeroPrefactura" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="fechaPrefactura">Fecha de prefactura</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker" formControlName="fechaPrefactura">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
              <mat-datepicker #datepicker>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="autofactura">Prefactura</label>
          <div fxLayout="row" fxLayoutAlign="space-between center"
            *ngIf="(this.factura?.documentoAutofactura != undefined)" class="centrar archivo">
            <div><span class="sprite-icon ico-adjuntar"></span><span
                class="nombre-archivo">{{this.factura?.documentoAutofactura?.nombre}}
              </span>
              <mat-icon *ngIf="canAccessDonwloadSelfInvoice()" (click)="descargar(this.factura?.documentoAutofactura)"
                matTooltip="Descargar" class="ml-2 color-custom pointer-cursor">
                download</mat-icon>
            </div>
          </div>
        </div>
      </div>
      <!--FACTURA-->
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="numeroFactura">Número factura gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="numeroFactura" id="numeroFactura" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="fechaFactura">Fecha factura</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker2" formControlName="fechaFactura">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker2"></mat-datepicker-toggle>
              <mat-datepicker #datepicker2>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="autofactura">Factura</label>
          <span *ngIf="canAccessUpInvoice()">
            <input #file type="file" (change)="file && file.files && attachAdjunto(file.files[0])" class="hide"
              id="adjuntar" name="adjuntar">
            <mat-icon (click)="openModalUploadInvoice()" class="ml-2 color-custom pointer-cursor"
              matTooltip="Adjuntar documento">upload_file</mat-icon>
          </span>
          <div class="custom-mat-field">
            <div class="attach">
              <div>
                <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="(this.factura?.documento != undefined)"
                  class="centrar archivo">
                  <div><span class="sprite-icon ico-adjuntar"></span><span
                      class="nombre-archivo">{{this.factura.documento!.nombre}}
                    </span>
                    <mat-icon *ngIf="canAccessDonwloadInvoice()" (click)="descargar(this.factura.documento)"
                      class="ml-2 color-custom pointer-cursor" matTooltip="Descargar">
                      download</mat-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row form" *ngIf="this.mostrarAbono">
        <div class="col-sm flex-grow-1">
          <label for="importeAbono">Importe abono (€)</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="importeAbono" id="importeAbono" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="cantidad">Cantidad (Kg) </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="cantidad" id="cantidad" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-2">
          <label for="motivoAbono">Motivo abono</label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="motivoAbono" id="motivoAbono" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1" *ngIf="canViewRegistrada()">
          <label for="registrada">Registrada</label>
          <div class="custom-mat-field">
            <mat-checkbox formControlName="registrada" color="primary"></mat-checkbox>
          </div>
        </div>
        <div class="col-sm flex-grow-1"></div>
        <div class="col-sm flex-grow-1"></div>
      </div>
      <!--UIPATH-->
      <div class="title-group">Datos de UIPATH</div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="numeroFacturaUipath">Número de factura </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="numeroFacturaUipath" id="numeroFacturaUipath" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="fechaFacturaUipath">Fecha de factura</label>
          <div class="custom-mat-field">
            <mat-form-field appearance="outline" class="custom-mat-form-field">
              <input matInput [matDatepicker]="datepicker3" formControlName="fechaFacturaUipath">
              <mat-datepicker-toggle matIconSuffix [for]="datepicker3"></mat-datepicker-toggle>
              <mat-datepicker #datepicker3>
              </mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <!-- Pendiente de definir si hay un cambio de nombre. De momento se cambia el nombre de la etiqueta en el front a esperas de cambios en el back. -->
          <label for="poseedorUipath">CIF Gestor </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="poseedorUipath" id="poseedorUipath" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="baseImponibleUipath">Base imponible / Importe </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="baseImponibleUipath" id="baseImponibleUipath" matInput type="number"
                DirectDecimalNumber>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="tipoIvaUipath">Tipo de IVA </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="tipoIvaUipath" id="tipoIvaUipath" matInput type="number"
                DirectDecimalNumber>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="importeIvaUipath">Importe de IVA </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="importeIvaUipath" id="importeIvaUipath" matInput type="number"
                DirectDecimalNumber>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row form">
        <div class="col-sm flex-grow-1">
          <label for="totalFacturaUipath">Total factura </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="totalFacturaUipath" id="totalFacturaUipath" matInput type="number"
                DirectDecimalNumber>
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="ibanUipath">IBAN </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="ibanUipath" id="ibanUipath" type="text">
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm flex-grow-1">
          <label for="swiftUipath">SWITF </label>
          <div class="custom-mat-field">
            <mat-form-field class="custom-mat-form-field" appearance="outline">
              <input matInput formControlName="swiftUipath" id="swiftUipath" type="text">
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="fixed-footer">
    <div class="modal-footer actions">
      <div class="note"></div>
      <div class="button-group">
        <button type="button" (click)="closeDialog()" class="btn btn-outline-primary" data-dismiss="modal"
          aria-label="Close">Volver</button>
        <button *ngIf="canAccessDonwloadSelfInvoice()" type="button" class="btn btn-primary" data-dismiss="modal"
          aria-label="Close" (click)="descargarDetallePrefacturacion()">Descargar detalle prefacturación</button>
        <button *ngIf="canAccessAcceptInvoice()" type="button" class="btn btn-primary" data-dismiss="modal"
          aria-label="Close" (click)="aceptarFactura()">Aceptar factura</button>
        <button *ngIf="canRejectInvoice()" type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close"
          (click)="openModalMotivoRechazo()">Rechazar</button>
        <button *ngIf="canAccessRegistrate()" type="button" class="btn btn-primary" data-dismiss="modal"
          aria-label="Close" (click)="registrarFactura()">Registrar</button>
        <button *ngIf="canAccessCrearAbono()" type="button" class="btn btn-primary" data-dismiss="modal"
          aria-label="Close" (click)="crearAbono()">Crear abono</button>
      </div>
    </div>
  </div>

</div>
